var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0724 2.50903C20.4624 2.50903 22.7324 4.88903 22.7324 8.42903V16.6C22.7324 20.129 20.4624 22.509 17.0724 22.509H8.40242C5.01242 22.509 2.73242 20.129 2.73242 16.6V8.42903C2.73242 4.88903 5.01242 2.50903 8.40242 2.50903H17.0724ZM16.9124 9.50903C16.5724 9.16903 16.0124 9.16903 15.6724 9.50903L11.5424 13.639L9.79242 11.889C9.45242 11.549 8.89242 11.549 8.55242 11.889C8.21242 12.229 8.21242 12.779 8.55242 13.129L10.9324 15.499C11.1024 15.669 11.3224 15.749 11.5424 15.749C11.7724 15.749 11.9924 15.669 12.1624 15.499L16.9124 10.749C17.2524 10.409 17.2524 9.85903 16.9124 9.50903Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tickIcon.e7dc9284753f3bd6e79acf4a3ef062fc.svg";
export { ForwardRef as ReactComponent };